// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hideDefaultIcon {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  position: absolute;
  width: 0;
  height: 0;
  overflow: hidden;
  margin: 0;
  padding: 0;
}

.posCustomRadioButtonLabel {
  cursor: pointer;
  display: flex;
  align-items: center;
  
}

.posCustomRadioButtonWrapper {
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-width: max-content;
}

.posCustomRadioIcon {
  width: 16px;
  height: 16px;
  border: 2px solid var(--surface-g3);
  border-radius: 50%;
  background: var(--surface-white);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  cursor: pointer;
}

.posCustomRadioIcon.black-s {
  border: 2px solid var(--surface-g3) !important;
}

.posCustomRadioIcon.black-s.act {
  border: 2px solid var(--blue-b0) !important;
}

.posCustomRadioIconLabel {
  display: flex;
  align-items: center;
  cursor: pointer;
}

/* ── Dark theme ── */
.dark .posCustomRadioIcon {
  background: #1e293b;
  border-color: #475569;
}`, "",{"version":3,"sources":["webpack://./client/src/customComponents/PosCustomRadioButton/PosCustomRadioButton.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;;AAErB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,kBAAkB;EAClB,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,qBAAqB;AACvB","sourcesContent":[".hideDefaultIcon {\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  position: absolute;\n  width: 0;\n  height: 0;\n  overflow: hidden;\n  margin: 0;\n  padding: 0;\n}\n\n.posCustomRadioButtonLabel {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  \n}\n\n.posCustomRadioButtonWrapper {\n  padding: 0.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  min-width: max-content;\n}\n\n.posCustomRadioIcon {\n  width: 16px;\n  height: 16px;\n  border: 2px solid var(--surface-g3);\n  border-radius: 50%;\n  background: var(--surface-white);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  cursor: pointer;\n}\n\n.posCustomRadioIcon.black-s {\n  border: 2px solid var(--surface-g3) !important;\n}\n\n.posCustomRadioIcon.black-s.act {\n  border: 2px solid var(--blue-b0) !important;\n}\n\n.posCustomRadioIconLabel {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n/* ── Dark theme ── */\n.dark .posCustomRadioIcon {\n  background: #1e293b;\n  border-color: #475569;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
